import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import RRRatingSquare from '../SharedComponents/RRRatingSquare'

import {styles} from '../CSS/Styles';

class RiskRating extends Component {
    constructor(props) {
		super(props);
        this.state = {
            value:0
        }
    }

    getTasks() {

    }
    getAlerts() {

    }
    getInitialState() {
    }

    componentDidMount() {
    }

    componentWillMount() {
        this.getFilter()
    }

    handleChange = name => event => {
        this.setState({ [name]: event.target.checked })
    };

    getFilter() {
        let filterData = {
            Threshold: ['High', 'Medium', 'Low'],
            Risk: ['On Target', 'Improve', 'Worsen', 'No Change']
        }
        this.setState( { filter: filterData } )
        for (let val in filterData) {
            let data = filterData[val]
            for (let filter in data){
                this.setState({ [data[filter]]: true })
            }
        }
    }

    render() {
        const { classes } = this.props;


        const filters = ()=>{
            let filterJSX = []
            for (var filter in this.state.filter) {
                filterJSX.push(
                    <div style={{ textAlign: 'left', paddingLeft: '10px'}}>
                        <typography style={{ display: 'inline-block', minWidth: '120px'}}> {filter} : </typography>
                        {this.state.filter[filter].map((data)=>{
                            return (
                                <div style={{display:'inline-block', textAlign:'left', minWidth:'120px'}}>
                                    <Checkbox
                                        checked={this.state[data]}
                                        onChange={this.handleChange(data)}
                                        value={data}
                                        color='primary'
                                    />
                                    <typography> {data} </typography>
                                </div>
                            )
                        })}
                    </div>
                )
            }
            return filterJSX
        }
        const filterheader = filters();

        const table = (
            <Table padding='dense'>
                <TableHead>
                    <TableRow style={{ height: '40px' }}>
                        <TableCell rowSpan={2}> No. </TableCell>
                        <TableCell rowSpan={2}> Key Risk </TableCell>
                        <TableCell rowSpan={2}> Target Rating </TableCell>
                        <TableCell align = 'center' colSpan = {5}> Residual Risks </TableCell>
                    </TableRow>
                    <TableRow style={{ height: '40px' }}>
                        <TableCell> Q1 FY 2019 </TableCell>
                        <TableCell> Q4 FY 2018 </TableCell>
                        <TableCell> Q3 FY 2018 </TableCell>
                        <TableCell> Q2 FY 2018 </TableCell>
                        <TableCell> Q1 FY 2018 </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.state.Medium === false ? null :
                        <TableRow>
                            <TableCell> R3 </TableCell>
                            <TableCell> Talent Attraction & Retention Risk  </TableCell>
                            <TableCell>
                                <RRRatingSquare type='current' name = 'Medium'/>
                                <br/><br/>
                                Likelihood: 3<br/>
                                Impact: 3
                            </TableCell>
                            <TableCell>
                                <RRRatingSquare type='past' name = 'Medium'/>
                                <br/><br/><br/><br/>
                                Likelihood: 3<br/>
                                Impact: 3
                            </TableCell>
                            <TableCell>     
                                <RRRatingSquare type='past' name = 'Medium'/>
                                <br/><br/><br/><br/>
                                Likelihood: 3<br/>
                                Impact: 3 
                            </TableCell>
                            <TableCell>    
                                <RRRatingSquare type='past' name = 'High'/>
                                <br/><br/><br/><br/>
                                Likelihood: 3<br/>
                                Impact: 3 
                            </TableCell>
                            <TableCell>     
                                <RRRatingSquare type='past' name = 'High'/>
                                <br/><br/><br/><br/>
                                Likelihood: 3<br/>
                                Impact: 3 
                            </TableCell>
                            <TableCell>     
                                <RRRatingSquare type='past' name = 'High'/>
                                <br/><br/><br/><br/>
                                Likelihood: 3<br/>
                                Impact: 3 
                            </TableCell>
                        </TableRow>
                    }
                    {this.state.Medium === false ? null :
                        <TableRow>
                            <TableCell> R5 </TableCell>
                            <TableCell> Branding and Media Risk </TableCell>
                            <TableCell>
                                <RRRatingSquare type='current' name = 'Medium'/>
                                <br/><br/>
                                Likelihood: 3<br/>
                                Impact: 3
                            </TableCell>
                            <TableCell>
                                <RRRatingSquare type='past' name = 'Medium'/>
                                <br/><br/><br/><br/>
                                Likelihood: 3<br/>
                                Impact: 3
                            </TableCell>
                            <TableCell>
                                <RRRatingSquare type='past' name = 'Medium'/>
                                <br/><br/><br/><br/>
                                Likelihood: 3<br/>
                                Impact: 3
                            </TableCell>
                            <TableCell>
                                <RRRatingSquare type='past' name = 'High'/>
                                <br/><br/><br/><br/>
                                Likelihood: 3<br/>
                                Impact: 3
                            </TableCell>
                            <TableCell>
                                <RRRatingSquare type='past' name = 'High'/>
                                <br/><br/><br/><br/>
                                Likelihood: 3<br/>
                                Impact: 3
                            </TableCell>
                            <TableCell>
                                <RRRatingSquare type='past' name = 'High'/>
                                <br/><br/><br/><br/>
                                Likelihood: 3<br/>
                                Impact: 3
                            </TableCell>
                        </TableRow>
                    }
                    {this.state.Low === false ? null :
                        <TableRow>
                            <TableCell> R7 </TableCell>
                            <TableCell> Regulatory Non-Compliance Risk </TableCell>
                            <TableCell>
                                <RRRatingSquare type='current' name = 'Low'/>
                                <br/><br/>
                                Likelihood: 3<br/>
                                Impact: 3
                            </TableCell>
                            <TableCell>
                                <RRRatingSquare type='past' name = 'Medium'/>
                                <br/><br/><br/><br/>
                                Likelihood: 3<br/>
                                Impact: 3
                            </TableCell>
                            <TableCell>
                                <RRRatingSquare type='past' name = 'Medium'/>
                                <br/><br/><br/><br/>
                                Likelihood: 3<br/>
                                Impact: 3
                            </TableCell>
                            <TableCell>
                                <RRRatingSquare type='past' name = 'High'/>
                                <br/><br/><br/><br/>
                                Likelihood: 3<br/>
                                Impact: 3
                            </TableCell>
                            <TableCell>
                                <RRRatingSquare type='past' name = 'High'/>
                                <br/><br/><br/><br/>
                                Likelihood: 3<br/>
                                Impact: 3
                            </TableCell>
                            <TableCell>
                                <RRRatingSquare type='past' name = 'High'/>
                                <br/><br/><br/><br/>
                                Likelihood: 3<br/>
                                Impact: 3
                            </TableCell>
                        </TableRow>
                    }
                </TableBody>
            </Table>
        )
        return (
            <div flexGrow={1}>
                {filterheader}
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Card className={classes.card_fit_content}>
                            <CardContent className={classes.content}>
                                {table}
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}
export default withStyles(styles)(RiskRating);


// WEBPACK FOOTER //
// ./src/components/Dashboard/ERMRiskRatingDashboard.js